// ui actions
export const UPDATE_UH_COMPONENT_SHOWING_NOW =
  'UPDATE_UH_COMPONENT_SHOWING_NOW';
export const UPDATE_HEADER_RELOAD_AND_BACK = 'UPDATE_HEADER_RELOAD_AND_BACK';
export const UPDATE_CONTENT_SUGG_USER_INPUT = 'UPDATE_CONTENT_SUGG_USER_INPUT';
export const TOGGLE_USER_INPUT = 'TOGGLE_USER_INPUT';
export const TOGGLE_MAIN_WINDOW_AND_FAB = 'TOGGLE_MAIN_WINDOW_AND_FAB';
export const UPDATE_SKILLS_RESPONSE = 'UPDATE_SKILLS_RESPONSE';
export const UPDATE_EXCEPTION_MSG = 'UPDATE_EXCEPTION_MSG';
export const UPDATE_RESOLVED_SUPP_SKILL = 'UPDATE_RESOLVED_SUPP_SKILL';
export const UPDATE_SELECTED_PRODUCT = 'UPDATE_SELECTED_PRODUCT';
export const UPDATE_SELECTED_VERSION = 'UPDATE_SELECTED_VERSION';
export const UPDATE_SHOW_PRODUCT_PICKER = 'UPDATE_SHOW_PRODUCT_PICKER';
export const UPDATE_SFDC_TYPE = 'UPDATE_SFDC_TYPE';
export const UPDATE_SFDC_TOPIC = 'UPDATE_SFDC_TOPIC';
export const UPDATE_PREMIUM_SUPPORT_SKILL = 'UPDATE_PREMIUM_SUPPORT_SKILL';
export const UPDATE_PREMIUM_SFDC_TYPE = 'UPDATE_PREMIUM_SFDC_TYPE';
export const UPDATE_PREMIUM_SFDC_TOPIC = 'UPDATE_PREMIUM_SFDC_TOPIC';
export const DISABLE_NAVBAR = 'DISABLE_NAVBAR';
export const SHOW_FAIL_SCREEN = 'SHOW_FAIL_SCREEN';
export const TOGGLE_POP_UP_MAIN_WINDOW = 'TOGGLE_POP_UP_MAIN_WINDOW';
export const OPEN_UHM_THROUGH_LINK = 'OPEN_UHM_THROUGH_LINK';
export const UPDATE_USER_INTERACTION = 'UPDATE_USER_INTERACTION';
export const UPDATE_CONTEXTUAL_LINK_ORIGIN = 'UPDATE_CONTEXTUAL_LINK_ORIGIN';
export const UPDATE_LINK_LOCATION = 'UPDATE_LINK_LOCATION';
export const UPDATE_CONTACT_APP_LOADING = 'UPDATE_CONTACT_APP_LOADING';
export const QUICK_TOGGLE_SHOW_PHONE_FOOTER = 'QUICK_TOGGLE_SHOW_PHONE_FOOTER';
export const HIDE_SECONDARY_NAV = 'HIDE_SECONDARY_NAV';
export const SHOW_CONFIRM_MODAL = 'SHOW_CONFIRM_MODAL';
export const SHOW_ADDITIONAL_QUESTIONS = 'SHOW_ADDITIONAL_QUESTIONS';
export const UPDATE_UI_DATA = 'UPDATE_UI_DATA';
export const RESET_UI_STATES = 'RESET_UI_STATES';
export const RESET_TO_HOME = 'RESET_TO_HOME';
export const CONTAINER_EVENT_MESSAGE = 'CONTAINER_EVENT_MESSAGE';
export const UPDATE_FAB_HEADER_COLORS = 'UPDATE_FAB_HEADER_COLORS';
export const UPDATE_IS_CHAT_ACTIVE = 'UPDATE_IS_CHAT_ACTIVE';
export const IS_END_CHAT_THROUGH_BUTTON = 'IS_END_CHAT_THROUGH_BUTTON';
export const UPDATE_SHOW_OVERLAY_COMPONENT = 'UPDATE_SHOW_OVERLAY_COMPONENT';
export const HAS_INTRUCTIONAL_TEXT = 'HAS_INTRUCTIONAL_TEXT';
export const UPDATE_USER_INPUT_FROM_AVA = 'UPDATE_USER_INPUT_FROM_AVA';
export const UPDATE_OPEN_AFTER_REDIRECT = 'UPDATE_OPEN_AFTER_REDIRECT'
export const UPDATE_REQUEST_ID = 'UPDATE_REQUEST_ID'

//Ava action types
export const TOGGLE_AVA_LOADING = 'TOGGLE_AVA_LOADING';
export const SHOW_AVA_MODAL = 'SHOW_AVA_MODAL';
export const CLOSE_AVA_MODAL = 'CLOSE_AVA_MODAL';
export const UPDATE_UHM_SUB_HEADER_TYPE = 'UPDATE_UHM_SUB_HEADER_TYPE';
export const UPDATE_SAVE_CHAT_TRIGGER = 'UPDATE_SAVE_CHAT_TRIGGER';
export const UPDATE_END_CHAT_TRIGGER = 'UPDATE_END_CHAT_TRIGGER';

//Sales ChatBot action types
export const ANYTHING_ELSE_END_CHAT = 'ANYTHING_ELSE_END_CHAT';
// export const SHOW_AGENT_AVAILABILITY_COMPONENT =
//   'SHOW_AGENT_AVAILABILITY_COMPONENT';
export const SHOW_AGENT_AVAILABILITY_FALLBACK_COMPONENT =
  'SHOW_AGENT_AVAILABILITY_FALLBACK_COMPONENT';
export const SHOW_ANYTHING_ELSE_COMPONENT = 'SHOW_ANYTHING_ELSE_COMPONENT';
export const SHOW_PHONE_HOUR_BUBBLE_COMPONENT =
  'SHOW_PHONE_HOUR_BUBBLE_COMPONENT';
export const DEEPLINK_CA_EDU_FLOW = 'DEEPLINK_CA_EDU_FLOW';

// disambiguation question actions
export const FETCH_WORKFLOW = 'FETCH_WORKFLOW';
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const UPDATE_CURRENT_GUID = 'UPDATE_CURRENT_GUID';
export const UPDATE_SEEN_GUIDS = 'UPDATE_SEEN_GUIDS';
export const UPDATE_CURRENT_PROMPT = 'UPDATE_CURRENT_PROMPT';
export const UPDATE_CURRENT_TOP_LEVEL_BRANCH =
  'UPDATE_CURRENT_TOP_LEVEL_BRANCH';
export const RESET_DISAMBIGUATION_STATES = 'RESET_DISAMBIGUATION_STATES';

// worflow default flags
export const UPDATE_DEFAULT_SUPPORT_SKILL = 'UPDATE_DEFAULT_SUPPORT_SKILL';
export const UPDATE_SHOW_CONTACT_FOOTER = 'UPDATE_SHOW_CONTACT_FOOTER_FLAG';
export const UPDATE_DEFAULT_ESCAPE_ACTION_GUID =
  'UPDATE_DEFAULT_ESCAPE_ACTION_GUID';
export const UPDATE_SHOW_CONTACT_DETAILS_IN_ACTION =
  'UPDATE_SHOW_CONTACT_DETAILS_IN_ACTION';
export const UPDATE_HIDE_TOPIC_NOT_LISTED = 'UPDATE_HIDE_TOPIC_NOT_LISTED';
export const UPDATE_HIDE_CONTACT = 'UPDATE_HIDE_CONTACT';
export const UPDATE_SHOW_RESELLER_CONTACT = 'UPDATE_SHOW_RESELLER_CONTACT';
export const UPDATE_USER_CONTEXT = 'UPDATE_USER_CONTEXT';
export const UPDATE_LINK_TO_ADN_SUPPORT_PAGE =
  'UPDATE_LINK_TO_ADN_SUPPORT_PAGE';

// workflow settings
export const UPDATE_SETTINGS_SITE_DATA = 'UPDATE_SETTINGS_SITE_DATA';
export const UPDATE_PRODUCT_DETAILS = 'UPDATE_PRODUCT_DETAILS';
export const UPDATE_CATALOG = 'UPDATE_CATALOG';
export const UPDATE_HAS_BEEN_REDIRECTED = 'UPDATE_HAS_BEEN_REDIRECTED';
export const UPDATE_SUB_ORIGIN = 'UPDATE_SUB_ORIGIN';
export const UPDATE_ME_MENU_AVAILABLE = 'UPDATE_ME_MENU_AVAILABLE';
export const SESSION_TOKEN_AVAILABLE = 'SESSION_TOKEN_AVAILABLE';
export const UPDATE_ME_MENU_LOADING = 'UPDATE_ME_MENU_LOADING';

// user data
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const UPDATE_ETE_SIGNATURE = 'UPDATE_ETE_SIGNATURE';
export const UPDATE_TRANS_SESS_ID = 'UPDATE_TRANS_SESS_ID';
export const TOGGLE_LOGIN_HAPPENING = 'TOGGLE_LOGIN_HAPPENING';
export const RESET_LOGIN = 'RESET_LOGIN';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_EXPORT_CONTROL_BLOCK = 'UPDATE_EXPORT_CONTROL_BLOCK';
export const UPDATE_ACCOUNTS_CSNS = 'UPDATE_ACCOUNTS_CSNS';
export const UPDATE_BLOCKED_CSN = 'UPDATE_BLOCKED_CSN';
export const UPDATE_BLOCKED_ACCOUNT_NAME = 'UPDATE_BLOCKED_ACCOUNT_NAME';

// content suggestion loading state
export const UPDATE_CONTENT_SUGG_LOADING = 'UPDATE_CONTENT_SUGG_LOADING';

// feedback widget toggle state
export const SHOW_FEEDBACK_WIDGET_FLOW = 'SHOW_FEEDBACK_WIDGET_FLOW';
export const FEEDBACK_WIDGET_MOUNTED = 'FEEDBACK_WIDGET_MOUNTED';

// analytics
export const UPDATE_RECOMMENDED_LINKS_ADP_DATA =
  'UPDATE_RECOMMENDED_LINKS_ADP_DATA';
export const UPDATE_SUGG_ARTICLES = 'UPDATE_SUGG_ARTICLES';
export const UPDATE_SUGG_ARTICLE_TYPE = 'UPDATE_SUGG_ARTICLE_TYPE';
export const RESET_ANALYTICS_STATES = 'RESET_ANALYTICS_STATES';

// launch Darkly
export const UPDATE_LD_FLAGS = 'UPDATE_LD_FLAGS';
export const UPDATE_LD_ID = 'UPDATE_LD_ID';
export const UPDATE_LD_CLIENT = 'UPDATE_LD_CLIENT';
